import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { OrdersService } from '../../services/orders/orders.service';
import {OrderItem} from '../../models/orderItem';
import { AlertComponent } from '../../../shared/components/dialogs/alert/alert.component';

@Component({
  selector: 'app-requested-items-component',
  imports: [
      CommonModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatInputModule,
      MatIconModule,
      MatButtonModule,
      MatDialogModule,
      TranslateModule,
      FlexLayoutModule,
      MatTableModule,
    ],
  standalone: true,
  templateUrl: './requested-items-component.component.html',
  styleUrl: './requested-items-component.component.scss'
})
export class RequestedItemsComponent implements OnInit {
  @Input() projectDescription: string = '';
  @Input() generalRemarks: string = '';
  @Input() rejectionJustification: string = '';
  @Input() cancelledJustification: string = '';
  @Input() isRequester: boolean = false;
  @Input() isRejected: boolean = false;
  @Input() isCancelled: boolean = false;
  @Input() itemsData: OrderItem[] = [];

  orderId: string | null;
  displayedColumns: string[] = ['codItem', 'partNumber', 'item', 'category', 'manufacturer', 'quantity'];

  constructor(
    private route: ActivatedRoute,
  ) {
    this.orderId = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit(): void {
  }
}
